var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M17.2169739,12.5659826 L13.6978435,12.5659826 L13.6978435,23.8903304 L8.48097391,23.8903304 L8.48097391,12.5659826 L6.00010435,12.5659826 L6.00010435,8.13276522 L8.48097391,8.13276522 L8.48097391,5.26372174 C8.48097391,3.21276522 9.45558261,-0.000104347826 13.7442783,-0.000104347826 L17.6082783,0.0165913043 L17.6082783,4.31937391 L14.8044522,4.31937391 C14.3448,4.31937391 13.6978435,4.54946087 13.6978435,5.52772174 L13.6978435,8.13693913 L17.6724522,8.13693913 L17.2169739,12.5659826 Z"}));
}

Facebook.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Facebook;

Facebook.default = Facebook;
